type PositionAttribute = "top" | "left" | "width";

export const updateElementPosition = (
  element: HTMLElement | null,
  position: Partial<Record<PositionAttribute, string>>
): void => {
  Object.entries(position).forEach(([attribute, value]) => element?.style.setProperty(attribute, value));
};
